import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../../config/config';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, FormGroup } from 'reactstrap';
import classnames from 'classnames';
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } 
from "../../common/renderinput";
import validate from './validate'
import Address from '../../common/address'
import CardHeader from 'reactstrap/lib/CardHeader';

class VendorBasicForm extends Component {
    render(){
        return (
            <>
            <form onSubmit={this.props.handleSubmit}>
            <Row form>
            <Col md={6}>
                <Card className="w-100">
                    <CardHeader as="" >Basic</CardHeader>
                <CardBody>
                        
                    <FormGroup>
                        <Field name="VendorId" component={renderInput} label="Vendor Id" />
                        <Field name="Name" component={renderInput} label="Name" />
                        <Field name="DBAName" component={renderInput} label="DBA" />
                        <Field name="TaxType" component={renderInput} label="Tax Type" />
                        <Field name="TaxId" component={renderInput} label="Tax Id" />
                    </FormGroup>
                </CardBody>
                </Card>
            </Col>
            <Col md={6}>
            <Card className="w-100">
            <CardHeader as="" >Address</CardHeader>
                <CardBody>
                        <Address />
                </CardBody>
                </Card>
            </Col>
        </Row>

        <Card className="col-12 mb-3">
                    <CardBody>
                    <div className="text-right">
                        <Button  type="submit" >Next</Button>
                    </div>
                    </CardBody>
        </Card>
        </form>
        </>
        )
    }
}
export default reduxForm({
    form: 'CreateVendorForm', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
  })(VendorBasicForm)